import { createStyles, makeStyles } from '@mui/styles';
import { Colors } from '../../layout/theme-next';
import { NextTheme } from '../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => createStyles({
  select: {
    '& .MuiSelect-root': {
      padding: theme.spacing(1.5),
    },
  },
  menu: {
    '& .MuiListItem-root': {
      minHeight: 32,
    },
  },
  placeholderItem: {
    '&.Mui-selected': {
      backgroundColor: 'unset',
    },
    color: Colors.textDisabled,
  },
}));
